var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 23.625C9.12887 23.625 10.5 22.2539 10.5 20.5625C10.5 18.8711 9.12887 17.5 7.4375 17.5C5.74613 17.5 4.375 18.8711 4.375 20.5625C4.375 22.2539 5.74613 23.625 7.4375 23.625Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 10.4998C22.2539 10.4998 23.625 9.12863 23.625 7.43726C23.625 5.74588 22.2539 4.37476 20.5625 4.37476C18.8711 4.37476 17.5 5.74588 17.5 7.43726C17.5 9.12863 18.8711 10.4998 20.5625 10.4998Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 10.4998C9.12887 10.4998 10.5 9.12863 10.5 7.43726C10.5 5.74588 9.12887 4.37476 7.4375 4.37476C5.74613 4.37476 4.375 5.74588 4.375 7.43726C4.375 9.12863 5.74613 10.4998 7.4375 10.4998Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 17.5V16.625C7.43751 15.9288 7.71408 15.2612 8.20635 14.7689C8.69862 14.2766 9.36628 14.0001 10.0624 14.0001L17.9376 13.9999C18.6337 13.9999 19.3014 13.7234 19.7937 13.2311C20.2859 12.7388 20.5625 12.0712 20.5625 11.375V10.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 10.5V17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.d4c03493ef36966bcce2ae7eac2754fd.svg";
export { ForwardRef as ReactComponent };